export default __webpack_public_path__ + "static/media/placeholder.b8acd164.png";